"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFill = exports.StyledMask = exports.StyledCircle = exports.StyledWrapper = exports.StyledContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var utilsOolib_1 = require("../../utilsOolib");
exports.StyledContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n"], ["\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n"])));
exports.StyledWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n"], ["\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n  background-color: ", ";\n"])), function (_a) {
    var size = _a.size;
    return "".concat(size, "px");
}, function (_a) {
    var size = _a.size;
    return "".concat(size, "px");
}, function (_a) {
    var theme = _a.theme;
    return (0, utilsOolib_1.getPrimaryColor40)(theme.colors);
});
exports.StyledCircle = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
exports.StyledMask = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  width: ", ";\n  height: ", ";\n  clip: rect(\n    0px,\n    ", ",\n    ", ", \n    ", " \n  );\n  position: absolute;\n  border-radius: 50%;\n"], ["\n  ", "\n  width: ", ";\n  height: ", ";\n  clip: rect(\n    0px,\n    ", ",\n    ", ", \n    ", " \n  );\n  position: absolute;\n  border-radius: 50%;\n"])), function (_a) {
    var size = _a.size, transform = _a.transform;
    return transform
        ? "transform: ".concat(transform, ";")
        : '';
}, function (_a) {
    var size = _a.size;
    return "".concat(size, "px");
}, function (_a) {
    var size = _a.size;
    return "".concat(size, "px");
}, function (_a) {
    var size = _a.size;
    return "".concat(size, "px");
}, function (_a) {
    var size = _a.size;
    return "".concat(size, "px");
}, function (_a) {
    var size = _a.size;
    return "".concat(parseFloat(size.toString()) / 2 + 'px');
});
exports.StyledFill = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  border-radius: 50%;\n  position: absolute;\n  background-color: ", ";\n"], ["\n  ", "\n  border-radius: 50%;\n  position: absolute;\n  background-color: ", ";\n"])), function (_a) {
    var size = _a.size, transform = _a.transform;
    return "transform: ".concat(transform, ";\n     width: ").concat(size, "px;\n     height: ").concat(size, "px;\n     clip: rect(\n        ").concat(parseFloat(size.toString()) / 2 + 'px', ",\n       ").concat(size, "px,\n       0px\n     );");
}, function (_a) {
    var theme = _a.theme;
    return (0, utilsOolib_1.getPrimaryColor100)(theme.colors);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
